// List of available avatar IDs. Each ID maps to public/avatars/<id>.jpg.

export const AVATAR_IDS = [
  'nepali-1',
  'nepali-2',
  'nepali-3',
  'nepali-4',
  'nepali-5',
  'nepali-6',
  'nepali-7',
  'nepali-8',
  'nepali-9',
  'nepali-10',
  'nepali-11',
  'nepali-12',
];

// Pastel background colors paired with each avatar for visual variety.
// Cycles if AVATAR_IDS is longer than this list.
export const AVATAR_BACKGROUNDS = [
  '#FFE5B4',
  '#D4C5F9',
  '#B4E5FF',
  '#FFC5D4',
  '#C5F9D4',
  '#FFD4B4',
  '#E5C5FF',
  '#B4FFD4',
];

export const DEFAULT_AVATAR_ID = AVATAR_IDS[0];

export function avatarSrc(id) {
  return `/avatars/${id}.jpg`;
}

export function backgroundFor(id) {
  const idx = AVATAR_IDS.indexOf(id);
  const safeIdx = idx >= 0 ? idx : 0;
  return AVATAR_BACKGROUNDS[safeIdx % AVATAR_BACKGROUNDS.length];
}

export function randomAvatarId(excludeIds = []) {
  const pool = AVATAR_IDS.filter((id) => !excludeIds.includes(id));
  const arr = pool.length > 0 ? pool : AVATAR_IDS;
  return arr[Math.floor(Math.random() * arr.length)];
}

export function randomAvatarIds(count, excludeIds = []) {
  const pool = AVATAR_IDS.filter((id) => !excludeIds.includes(id));
  const shuffled = [...pool].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, Math.min(count, shuffled.length));
}
